import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import {Header2} from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import { API_URL, API_URL_SAVE_ANSWER, API_URL_PHOTO, SECRET_SESSION, PENGAWAS_API_URL } from "../constants.js";
import CountdownTimer from "./shares/CountdownTimer.js";
import { PiGridNine, PiMagnifyingGlassMinus, PiMagnifyingGlassPlus, PiClock, PiCaretRightBold } from "react-icons/pi";
import Loading from "./shares/Loading.jsx";
import InfoStatusJawab from "./shares/InfoStatusJawab.jsx";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import { decrypt, decrypt_res, encrypt_res } from "./shares/GlobalFunction.jsx";
import AlertModal from "./shares/AlertModal.js";
import PauseModal from "./shares/PauseModal.js";
import MessageModal from "./shares/MessageModal.js";
import moment from "moment-timezone";
import Loader from "./shares/Loader.jsx";
import AlertProgres from "./shares/AlertProgres.js";
import axiosInstance from "./shares/axiosConfig.js";
import {
  initializeNotificationSystem,
  // ACCESS_STATUS_CONFIG,
  // checkAccessStatus,
  // checkPesanPengawas,
  // registerFCMToken,
} from '../utils/testNotificationUtils';

function ProsesTestKraeplin() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [starTimer, setStarTimer] = useState("start");
  const [catatanPengawas, setCatatan] = useState('');
  const [isStopModalOpen, setStopModalOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [dataProjek, setDataProjek] = useState(null);
  const [isAlertTimeOutOpen, setAlertTimeOutOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  const [sesiSelesai, setSesiSelesai] = useState(false);
  const [isPauseModalOpen, setPauseModalOpen] = useState(false);
  const [accessStatus, setAccessStatus] = useState(null);
  const [fcmInitialized, setFcmInitialized] = useState(false);
  const [isMessageModalOpen, setModalMessageOpen] = useState(false);
  const [pesanPengawas, setPesanPengawas] = useState("");
  const [timeStamp, setTimeStamp] = useState("");

  const timerRef = useRef();
  const headerRef = useRef();
  const accessStatusCheckIntervalRef = useRef([]);
  const notificationCheckIntervalRef = useRef([]);
  const intervalRef = useRef([]);

  React.useEffect(() => {
    if (effectsCompleted >= 2) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    navigate("/login");
  }

  let id_test = localStorage.getItem("mulai_ujian");
  if (id_test) {
    id_test = JSON.parse(decrypt(id_test));
  } else {
    navigate("/login");
  }

  let kamera = localStorage.getItem("kamera");

  let id_ujian = localStorage.getItem("id_ujian");

  React.useEffect(() => {
    const statusTimeOut = localStorage.getItem('statusTimeOut_' + userData.id_siswa + '_' + id_test);
    setAlertTimeOutOpen(statusTimeOut === "true" || statusTimeOut === true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_test]);
  let last_countdown = localStorage.getItem("countdown");
  if (last_countdown) {
    last_countdown = parseInt(last_countdown) - 1;
  } else {
    last_countdown = 30;
  }

  const [countdown, setCountdown] = useState(last_countdown);

  let initialStatus = [].fill("");
  const [statusJawaban, setStatusJawaban] = useState(initialStatus);

  let sAktif = parseInt(localStorage.getItem("soalAktif")) || 0;
  const [soalAktif, setSoalAktif] = useState(sAktif);

  useEffect(() => {
    setActiveTabIndex(soalAktif);
    setNoSoal(soalAktif + 1);
  }, [soalAktif]);

  const [post, setPost] = React.useState(null);

  const clearAccessStatusCheckTimers = () => {
    accessStatusCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    accessStatusCheckIntervalRef.current = [];
  };

  const clearNotificationCheckTimers = () => {
    notificationCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    notificationCheckIntervalRef.current = [];
  };

  const clearAllTimers = () => {
    intervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    intervalRef.current = [];
    clearAccessStatusCheckTimers();
    clearNotificationCheckTimers();
  };

  React.useEffect(() => {
    window.AndroidBridge?.notifyExamStarted();

    initializeNotificationSystem(
      userData,
      id_ujian,
      accessStatusCheckIntervalRef,
      notificationCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      setFcmInitialized,
      setAlertTimeOutOpen
    );

    return () => {
      clearAccessStatusCheckTimers();
      clearNotificationCheckTimers();
    };
  }, [userData.id_projek, userData.id_siswa, userData.pengawas, id_ujian, navigate]);

  React.useEffect(() => {
    axios.post(API_URL + "/login/info").then((response) => {
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
    let accessToken = localStorage.getItem("token");
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, { headers: { Authorization: `Bearer ${accessToken}` } })
    .then((response) => {
      setDataProjek(response.data.res);
    });
  }, []);

  const [Subtest, setSubtest] = React.useState(null);
  React.useEffect(() => {
    const subtestPayload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };
    const encryptedSubtest = encrypt_res(JSON.stringify(subtestPayload), SECRET_SESSION);

    axiosInstance
      .post(API_URL + "/peserta/subtest", { data: encryptedSubtest })
      .then((response) => {
        let decResponse = JSON.parse(decrypt_res(response.data.data, SECRET_SESSION));
        let detailTes = decResponse[0];

        if (detailTes.error_message) {
          alert(detailTes.error_message);
          navigate("/peserta/logout");
          return;
        }

        if (detailTes.tipe_tes === 1) {
          navigate("/peserta/start_test");
        }

        if (parseInt(detailTes.jenis_tes) !== 20) {
          navigate("/peserta/start_test2");
        }

        setSubtest(detailTes);

        const daftarSoalPayload = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_projek_ujian: id_test,
          id_naskah: detailTes.id_naskah,
          kode_paket_soal: detailTes.id_paket_soal,
          id_ujian: id_ujian,
          timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };
        const encryptedDaftarSoal = encrypt_res(JSON.stringify(daftarSoalPayload), SECRET_SESSION);

        axiosInstance
          .post(API_URL + "/peserta/daftarsoal", { data: encryptedDaftarSoal })
          .then((response) => {
            response.data.data = JSON.parse(decrypt_res(response.data.data, SECRET_SESSION));
            response.data.answer = JSON.parse(decrypt_res(response.data.answer, SECRET_SESSION));

            setDaftarSoal(response.data.data);

            // Bangun data dari server sebagai base
            let serverStatusJawaban = [];
            let serverIdSoal = [];
            let serverWaktuMengerjakan = [];
            (Array.isArray(response.data.answer) ? response.data.answer : []).forEach((item) => {
              serverStatusJawaban[item.no_soal - 1] = parseInt(item.jenis_soal) === 1
                ? item.jawaban_pilihan
                : item.jawaban_essai;
              serverIdSoal[item.no_soal - 1] = item.id_soal;
              serverWaktuMengerjakan[item.no_soal - 1] = item.waktu_mengerjakan;
            });

            // Tiap field: prioritaskan localStorage, fallback ke server jika tidak ada
            const localStatusJawaban = localStorage.getItem("statusJawaban");
            const newStatusJawaban = localStatusJawaban
              ? JSON.parse(localStatusJawaban)
              : serverStatusJawaban;

            const localIdSoal = localStorage.getItem("idSoal");
            const newIdSoal = localIdSoal
              ? JSON.parse(localIdSoal)
              : serverIdSoal;

            const localWaktuMengerjakan = localStorage.getItem("waktuMengerjakan");
            const newWaktuMengerjakan = localWaktuMengerjakan
              ? JSON.parse(localWaktuMengerjakan)
              : serverWaktuMengerjakan;

            // Tulis ke localStorage agar autosave interval selalu punya data terbaru
            localStorage.setItem("idSoal", JSON.stringify(newIdSoal));
            localStorage.setItem("waktuMengerjakan", JSON.stringify(newWaktuMengerjakan));
            localStorage.setItem("statusJawaban", JSON.stringify(newStatusJawaban));
            // jenisSoal Kraeplin selalu 9 — inisialisasi sekali saja jika belum ada
            if (!localStorage.getItem("jenisSoal")) {
              const jenisSoalInit = response.data.data.listSoal.map(() => 9);
              localStorage.setItem("jenisSoal", JSON.stringify(jenisSoalInit));
            }

            setStatusJawaban(newStatusJawaban);
            setEffectsCompleted((prev) => prev + 1);
          });
      });
  }, [userData.id_projek, userData.id_siswa, id_ujian, id_test, navigate]);

  const [DaftarSoal, setDaftarSoal] = React.useState(null);

  useEffect(() => {
    const checkAndCapture = async () => {
      if (dataProjek && dataProjek.kamera !== 0) {
        const interval2 = setInterval(() => {
          if (headerRef.current) {
            let captureImage = headerRef.current.capture();
            if (captureImage) {
              const payload_capture = {
                id_projek: userData.id_projek,
                id_siswa: userData.id_siswa,
                id_ujian: 0,
                nopes: userData.nopes,
                image: captureImage,
                timeStamp: Math.floor(Date.now() / 1000)
              };
              const encryptedCapture = encrypt_res(JSON.stringify(payload_capture), SECRET_SESSION);
              axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", { data: encryptedCapture });
            }
          }
        }, 60000);
        intervalRef.current.push(interval2);
        return () => clearInterval(interval2);
      }
    };
    checkAndCapture();
  }, [dataProjek]);

  const saveAnswerRedis = () => {
    const localStatusJawaban = JSON.parse(localStorage.getItem("statusJawaban") || "[]");
    const localIdSoal = JSON.parse(localStorage.getItem("idSoal") || "[]");
    const localWaktuMengerjakan = JSON.parse(localStorage.getItem("waktuMengerjakan") || "[]");
    const localJenisSoal = JSON.parse(localStorage.getItem("jenisSoal") || "[]");

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      jumlah_soal: localIdSoal.length,
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join(","),
      jenisSoal: localJenisSoal.join(","),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      statusSave: "",
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_jawaban_redis", {
      data: encrypt_res(JSON.stringify(payload), SECRET_SESSION),
    });
  };

  // Untuk handleConfirm — final save sebelum selesaites
  const buildAutoSavePayload = () => {
    const localStatusJawaban = JSON.parse(localStorage.getItem("statusJawaban") || "[]");
    const localIdSoal = JSON.parse(localStorage.getItem("idSoal") || "[]");
    const localWaktuMengerjakan = JSON.parse(localStorage.getItem("waktuMengerjakan") || "[]");
    const localJenisSoal = JSON.parse(localStorage.getItem("jenisSoal") || "[]");
    return {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join("||"),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      statusSave: "",
      jenisSoal: localJenisSoal.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };
  };

  useEffect(() => {
    if (!isAlertTimeOutOpen) {
      const interval1 = setInterval(() => {
        saveAnswerRedis();
      }, 60000);
      intervalRef.current.push(interval1);
      return () => clearInterval(interval1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAlertTimeOutOpen]);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [noSoal, setNoSoal] = useState(1);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    setNoSoal(index + 1);
    setSoalAktif(index);
    setCountdown(parseInt(DaftarSoal.listSoal[index].waktu_stimulus));
    setJumlahBenar(0);
    setProblems([
      {
        num1: getRandomNumber(),
        num2: getRandomNumber(),
        answer: "",
        disabled: false,
      },
    ]);
    setTimeout(() => {
      if (document.getElementById("input" + index + "-0"))
        document.getElementById("input" + index + "-0").focus();
    }, 500);

    localStorage.setItem("soalAktif", index);
  };

  const handleNextTab = () => {
    if (DaftarSoal) {
      if (activeTabIndex < DaftarSoal.listSoal.length - 1) {
        let nextIndex = activeTabIndex + 1;
        handleTabChange(nextIndex);
      }
    }
  };

  const setTab = (index) => {
    if (canClikTab) {
      setActiveTabIndex(index);
      setNoSoal(index + 1);
    }
  };

  const [fontSize, setFontSize] = useState(16);

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 2);
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 10));
  };

  const handleFinishTest = () => {
    handleOpenModal();
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleOpenModalTimeout = () => {
    let lastInput = document.getElementById(
      "input" + soalAktif + "-" + (problems.length - 1)
    );
    if (lastInput) lastInput.disabled = true;
    if (!isAlertProgresOpen) {
      setAlertTimeOutOpen(true);
      clearAllTimers();
    }
  };

  const handleConfirm = () => {
    setModalOpen(false);
    setAlertTimeOutOpen(false);
    setAlertProgresOpen(true);

    axiosInstance
      .post(API_URL + "/peserta/autosave_jawaban", {
        data: encrypt_res(JSON.stringify(buildAutoSavePayload()), SECRET_SESSION),
      })
      .then(() => {
        const selesaiPayload = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_projek_ujian: id_test,
          id_ujian: parseInt(id_ujian),
          id_naskah: Subtest.id_naskah,
          jawaban: "",
          nopes: userData.nopes,
          kode_akses: userData.kode_akses,
        };
        return axiosInstance.post(API_URL + "/peserta/selesaites", {
          data: encrypt_res(JSON.stringify(selesaiPayload), SECRET_SESSION),
        });
      })
      .then((response) => {
        if (parseInt(response.data.data) === 1) {
          localStorage.removeItem("statusJawaban");
          localStorage.removeItem("mulai_ujian");
          localStorage.removeItem("id_ujian");
          navigate("/peserta/confirmtoken");
        } else {
          localStorage.removeItem("statusJawaban");
          localStorage.removeItem("mulai_ujian");
          localStorage.removeItem("id_ujian");
          navigate("/peserta/finish_test");
        }

        localStorage.removeItem("statusJawaban");
        localStorage.removeItem("tampilPertanyaan");
        localStorage.removeItem("tampilJawaban");
        localStorage.removeItem("soalAktif");
        localStorage.removeItem("canBack");
        localStorage.removeItem("waktuMengerjakan");
        localStorage.removeItem("idSoal");
        localStorage.removeItem("jenisSoal");
        localStorage.removeItem("countdown");

        if (dataProjek && dataProjek.kamera !== 0 && headerRef.current) {
          let captureImage = headerRef.current.capture();
          if (captureImage) {
            const payload_capture = {
              id_projek: userData.id_projek,
              id_siswa: userData.id_siswa,
              id_ujian: 0,
              nopes: userData.nopes,
              image: captureImage,
              timeStamp: Math.floor(Date.now() / 1000)
            };
            const encryptedCapture = encrypt_res(JSON.stringify(payload_capture), SECRET_SESSION);
            axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", { data: encryptedCapture });
          }
        }
      });
  };

  const handleConfirmStop = () => {
    setStopModalOpen(false);
    navigate('/peserta/logout');
  };

  const handleToEmpty = () => {
    let emptyIndex = statusJawaban.findIndex(
      (item) => item === "" || item === null || item === undefined
    );
    setAlertModalOpen(false);
    handleTabChange(emptyIndex);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setAlertModalOpen(false);
  };

  const [canClikTab] = useState(false);
  const [isVisibleNavigasiSoal, setIsVisibleNavigasiSoal] = useState(window.innerWidth > 640);
  const handleOpenNavigasiSoal = (status) => setIsVisibleNavigasiSoal(status);

  const [problems, setProblems] = useState([
    {
      num1: getRandomNumber(),
      num2: getRandomNumber(),
      answer: "",
      disabled: false,
    },
  ]);
  const [currentProblemIndex, setCurrentProblemIndex] = useState(0);
  const [jumlahBenar, setJumlahBenar] = useState(0);
  let tmpJumlahBenar = 0;

  function getRandomNumber() {
    return Math.floor(Math.random() * 9) + 1;
  }

  function handleInputChange(e, index, noSoal) {
    const newProblems = [...problems];
    newProblems[index].answer = e.target.value;
    setProblems(newProblems);
  }

  function handleKeyPress(e, index, noSoal) {
    if (e.key === "Enter") {
      if (isNaN(e.target.value) || e.target.value === "") {
        return;
      }
      const newProblems = [...problems];
      const { num1, num2, answer } = newProblems[index];
      let correctAnswer = num1 + num2;
      let lastDigit = correctAnswer % 10;

      if (
        parseInt(answer) === correctAnswer ||
        parseInt(answer) % 10 === lastDigit
      ) {
        tmpJumlahBenar = jumlahBenar + 1;
        setJumlahBenar(tmpJumlahBenar);

        setStatusJawaban((prev) => {
          let newStatus = [...prev];
          newStatus[noSoal] = tmpJumlahBenar;
          localStorage.setItem("statusJawaban", JSON.stringify(newStatus));

          const waktu_mengerjakan = moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss");

          const prevWaktu = JSON.parse(localStorage.getItem("waktuMengerjakan") || "[]");
          prevWaktu[noSoal] = waktu_mengerjakan;
          localStorage.setItem("waktuMengerjakan", JSON.stringify(prevWaktu));

          const prevIdSoal = JSON.parse(localStorage.getItem("idSoal") || "[]");
          prevIdSoal[noSoal] = e.target.title;
          localStorage.setItem("idSoal", JSON.stringify(prevIdSoal));

          // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
          //   id_projek: userData.id_projek,
          //   id_siswa: userData.id_siswa,
          //   id_ujian: id_ujian,
          //   id_soal: e.target.title,
          //   jenis_soal: 9,
          //   jawaban_pilihan: "",
          //   jawaban_essai: tmpJumlahBenar,
          //   waktu_mengerjakan: waktu_mengerjakan,
          // });

          setTimeout(() => {
            saveAnswerRedis();
          }, 1000);
          return newStatus;
        });
      }

      newProblems.push({
        num1: getRandomNumber(),
        num2: getRandomNumber(),
        answer: "",
      });
      setCurrentProblemIndex(currentProblemIndex + 1);
      newProblems[index].disabled = true;
      setTimeout(() => {
        if (document.getElementById("input" + soalAktif + "-" + (index + 1)))
          document.getElementById("input" + soalAktif + "-" + (index + 1)).focus();
      }, 500);

      setProblems(newProblems);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById("input" + soalAktif + "-0"))
        document.getElementById("input" + soalAktif + "-0").focus();
    }, 800);
  }, [soalAktif]);

  useEffect(() => {
    if (!DaftarSoal) return;
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
        localStorage.setItem("countdown", countdown);
      }, 1000);
      intervalRef.current.push(timer);
      return () => clearInterval(timer);
    } else {
      const isLastSesi = activeTabIndex === DaftarSoal.listSoal.length - 1;
      if (isLastSesi) {
        setSesiSelesai(true);
        setTimeout(() => saveAnswerRedis(), 500);
      } else {
        handleNextTab();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown, DaftarSoal]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="App" translate="no">
      <PauseModal
        isOpen={isPauseModalOpen}
        title={"Perhatian"}
        subtitle={"Tes Anda dihentikan sementara. Silahkan hubungi pengawas."}
      />
      <MessageModal
        isOpen={isMessageModalOpen}
        title="Pesan Pengawas"
        arrayMessages={pesanPengawas}
        subtitle={pesanPengawas}
        onConfirm={() => {
          axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read", {
            id_projek: userData.id_projek,
            id_siswa: userData.id_siswa,
            timestamp: timeStamp
          })
          .catch(() => {
            console.log("Network error pesan jadi tak terbaca");
          });
          setModalMessageOpen(false);
        }}
      />
      <AlertModal
        isOpen={isStopModalOpen}
        onConfirm={handleConfirmStop}
        title={"Catatan Penghentian Ujian"}
        subtitle={catatanPengawas}
        btn_text="Logout"
      />
      <AlertModal
        isOpen={alertVisible}
        onConfirm={() => setAlertVisible(false)}
        title={"Kesalahan Jaringan"}
        btn_text="Ok."
        subtitle={"Jaringan terganggu. Silakan coba lagi nanti."}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Apakah Anda yakin akan mengakhiri tes dan melanjutkan ke tes berikutnya ?"
        }
      />

      <AlertModal
        isOpen={isAlertModalOpen}
        onConfirm={handleToEmpty}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Silahkan lengkapi jawaban Anda terlebih dahulu sebelum menyelesaikan ujian."
        }
      />

      <AlertProgres
        isOpen={isAlertProgresOpen}
        title={"Sedang diproses ..."}
        subtitle={""}
      />

      <AlertModal
        isOpen={isAlertTimeOutOpen}
        onConfirm={handleConfirm}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Waktu tes anda sudah habis, silahkan klik tombol untuk menyelesaikan tes."
        }
      />
      <NoCopyText>
        <div className="App-header">
          <Header2 app_name={post && post.alamat} camera={dataProjek && dataProjek.kamera != 0} mobile = {isMobile} ref={headerRef}/>
          <div
            className="md:flex flex-row w-full gap-5 lg:px-[100px] sm:px-5"
            style={{ marginTop: "90px", marginBottom: "100px" }}
          >
            <div
              className="login-container w-full Bg-tutwuri z-10 bg-white border-2 border-grey-800 rounded-xl shadow-xl px-2 py-3 sm:p-5"
              style={{ minHeight: "200px" }}
            >
              <div className={!isVisibleNavigasiSoal ? "flex w-full lg:flex-row sm:flex-col flex-wrap gap-1" : "flex w-full lg:flex-row sm:flex-col flex-nowrap gap-1"}>

                {/* ── Kolom Kiri ── */}
                <div className="flex-grow px-1 py-2 sm:p-4">

                  {/* Header bar */}
                  <div className="flex justify-between pt-1 pb-3 items-center">
                    <div className="flex flex-row gap-4 items-center">
                      <div className="mt-1 font-bold whitespace-nowrap">
                        Sesi {noSoal}
                      </div>
                      <div className="text-sm mt-1 flex flex-row gap-2">
                        <PiMagnifyingGlassPlus onClick={increaseFontSize} className="text-xl cursor-pointer" />
                        <PiMagnifyingGlassMinus onClick={decreaseFontSize} className="text-xl cursor-pointer" />
                      </div>
                    </div>

                    {/* Per-soal countdown — kraeplin specific */}
                    <div className="flex items-center gap-1 px-3 py-1 border border-yellow-400 rounded-xl">
                      <span className="text-xs text-gray-500 hidden sm:inline">Waktu Sesi</span>
                      <span className="font-bold text-yellow-600 text-base">{countdown}s</span>
                    </div>

                    {/* Total timer */}
                    <div className="flex flex-row items-center gap-2 p-1 mr-1 border border-red-500 rounded-xl">
                      <PiClock />
                      {Subtest && (
                        <CountdownTimer
                          status={starTimer}
                          ref={timerRef}
                          initialSeconds={Subtest.sisa_waktu}
                          onTime={handleOpenModalTimeout}
                        />
                      )}
                    </div>
                  </div>
                  <div className="border-t-4 mb-1 border-gray-200 rounded"></div>

                  {/* Soal area */}
                  <div
                    className="contentSoal border-2 border-gray-200 rounded-md px-5 py-3 sm:p-4 z-1 custom-height-soal relative"
                    style={{ minHeight: "400px" }}
                  >
                    {sesiSelesai && (
                      <div className="absolute inset-0 bg-white/90 z-10 flex flex-col items-center justify-center gap-3 rounded-md">
                        <div className="text-3xl">⏱️</div>
                        <p className="text-lg font-bold text-red-600">Waktu sesi telah habis</p>
                        <p className="text-sm text-gray-500 text-center px-4">
                          Klik <strong>Selesai Subtes</strong> untuk menyelesaikan tes ini.
                        </p>
                      </div>
                    )}
                    {DaftarSoal ? (
                      <div
                        className="flex flex-row flex-wrap"
                        style={{ fontSize: `${fontSize}px`, fontFamily: "'Google Sans', sans-serif" }}
                      >
                        {DaftarSoal.listSoal.map((soal, index) => (
                          <div
                            key={soal.id_soal}
                            label={index + 1}
                            className={activeTabIndex === index ? "w-full" : "hidden"}
                          >
                            <div>
                              <div>{soal.soal && parseHtml(soal.soal)}</div>
                              <div className="grid grid-cols-1 gap-1 mt-3">
                                {problems.map((problem, idx) => (
                                  <div key={idx} className="flex items-center gap-2">
                                    <span className="w-20 text-right font-mono">
                                      {problem.num1} + {problem.num2} ={" "}
                                    </span>
                                    <input
                                      type="text"
                                      disabled={problem.disabled || sesiSelesai}
                                      id={"input" + index + "-" + idx}
                                      className="border-2 border-gray-200 rounded-md p-1 text-center w-20 disabled:opacity-50 disabled:cursor-not-allowed"
                                      value={problem.answer}
                                      title={soal.id_soal}
                                      onChange={(e) => handleInputChange(e, idx, index)}
                                      onKeyPress={(e) => handleKeyPress(e, idx, index)}
                                      maxLength={1}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <Loading />
                    )}
                  </div>

                </div>

                {/* ── Backdrop mobile ── */}
                {isVisibleNavigasiSoal && isMobile && (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-40"
                    onClick={() => handleOpenNavigasiSoal(false)}
                  />
                )}

                {/* ── Kolom Kanan — Daftar Soal ── */}
                <div
                  className={
                    isVisibleNavigasiSoal
                      ? isMobile
                        ? "fixed right-0 top-0 h-full w-4/5 bg-white z-50 p-4 overflow-auto shadow-lg transform translate-x-0 transition-transform duration-300 ease-in-out"
                        : "w-full lg:w-1/6 md:min-w-[300px]"
                      : isMobile
                        ? "fixed right-0 top-0 h-full hidden w-1/2 bg-white z-50 p-4 overflow-auto shadow-lg transform translate-x-full transition-transform duration-300 ease-in-out"
                        : "translate-x-full hidden w-full lg:w-1/6 p-4 md:min-w-[300px]"
                  }
                >
                  {/* Header panel — close button mobile / info desktop */}
                  <div className="border border-muted p-3 rounded-lg flex flex-row items-center backgroundColor mb-2 gap-2 shadow">
                    <div className="text-sm font-bold flex-1">DAFTAR SESI</div>
                    <PiCaretRightBold
                      className="cursor-pointer ml-auto"
                      onClick={() => handleOpenNavigasiSoal(false)}
                    />
                  </div>

                  <div className="border border-muted rounded-lg items-center mb-4 shadow py-4 px-2 contentSoal custom-height-soal lg:min-h-[395px]">
                    <div className="relative flex flex-row gap-1 justify-between py-2 px-2 items-center w-full">
                      <div className="text-sm font-bold ml-4">DAFTAR SESI</div>
                      <div className="mr-4">
                        <InfoStatusJawab />
                      </div>
                    </div>
                    {DaftarSoal ? (
                      <div className="text-sm">
                        <div className="flex flex-row justify-center flex-wrap">
                          {DaftarSoal.listSoal.map((soal, index) => (
                            <div className="relative inline-block" key={index}>
                              <div className="m-0 rounded-lg">
                                <button
                                  type="button"
                                  onClick={setTab.bind(this, index)}
                                  className={
                                    activeTabIndex === index
                                      ? "bg-[#01B224] border-1 border-blue-400 py-2 px-2 rounded m-1 text-white"
                                      : statusJawaban[index]
                                      ? "bg-[#2D7DBE] border border-gray-200 py-2 px-2 rounded m-1 text-white"
                                      : "bg-[#F3F3F3] border border-gray-200 py-2 px-2 rounded m-1 text-[#C9C9C9]"
                                  }
                                  style={{ width: "40px" }}
                                >
                                  {index + 1}
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* Tombol Selesai — desktop only, sesi terakhir */}
                        {!isMobile && activeTabIndex === DaftarSoal.listSoal.length - 1 && (
                          <div className="flex justify-center mt-4">
                            <button
                              type="button"
                              onClick={handleFinishTest}
                              className="flex justify-center items-center hover:bg-teal-600 text-white text-sm py-2 px-4 rounded-2xl backgroundColor w-full"
                            >
                              Selesai Subtes <PiCaretRightBold className="ml-1 flex-shrink-0" />
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <Loading />
                    )}
                  </div>
                </div>

                {/* Tab "Daftar Soal" — muncul ketika panel tersembunyi */}
                {!isVisibleNavigasiSoal && (
                  <div
                    className="absolute top-40 -right-[40px] rotate-90 p-1 text-sm font-bold bg-green-500 text-white rounded-b-lg shadow cursor-pointer z-10"
                    onClick={() => handleOpenNavigasiSoal(true)}
                  >
                    <div className="flex justify-end items-center gap-2">
                      Daftar Soal <PiGridNine />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── Bottom floating bar — mobile only ── */}
          {isMobile && DaftarSoal && activeTabIndex === DaftarSoal.listSoal.length - 1 && (
            <div className="fixed bottom-0 w-full left-0 px-5 py-1 z-30">
              <div className="login-container w-full mb-2 flex flex-row justify-end items-center p-4 bg-white rounded-xl shadow-xl">
                <button
                  type="button"
                  onClick={handleFinishTest}
                  className="flex justify-center items-center hover:bg-teal-600 text-white text-sm py-2 px-4 rounded-2xl backgroundColor"
                >
                  Selesai Subtes <PiCaretRightBold className="ml-1 flex-shrink-0" />
                </button>
              </div>
            </div>
          )}
        </div>
      </NoCopyText>
    </div>
  );
}

export default ProsesTestKraeplin;
